import { request } from '@umijs/max';

export type ClipboardClip = {
  id: string;
  text: string;
  pageName: string;
  href: string;
  createdAt: string;
};
export type ClipboardClipInput = Pick<ClipboardClip, 'text' | 'pageName' | 'href'>;
const endpoint = '/api/user/clipboard';

export async function getClipboardClips(): Promise<ClipboardClip[]> {
  const response = await request<{ success: boolean; data: ClipboardClip[] }>(endpoint, {
    skipErrorHandler: true,
  });
  if (!response.success) throw new Error('Could not load Clipboard');
  return response.data;
}

export async function saveClipboardClip(
  id: string,
  data: ClipboardClipInput,
): Promise<ClipboardClip> {
  const response = await request<{ success: boolean; data: ClipboardClip }>(`${endpoint}/${id}`, {
    method: 'PUT',
    data,
    skipErrorHandler: true,
  });
  if (!response.success) throw new Error('Could not save Clipboard stack');
  return response.data;
}

export async function deleteClipboardClip(id: string): Promise<void> {
  const response = await request<{ success: boolean }>(`${endpoint}/${id}`, {
    method: 'DELETE',
    skipErrorHandler: true,
  });
  if (!response.success) throw new Error('Could not remove Clipboard stack');
}
